export const access_token = async () => {
  return `${localStorage.getItem("access_token")}`;
};
